export default "/_nuxt/1bca51b803a500ee17f2839599a7789d.svg";